import { useWriteContract } from "@abraxas/ui/web3"
import { useCallback } from "react"
import { MARKETPLACE_CHAIN_ID } from "../marketplace-chain-id"
import { config } from "@repo/loomlock/client"
import { ABIOffersLogic } from "../abis/OffersLogic"

export function useAcceptOffer() {
  const { writeContractAsync, isPending } = useWriteContract("accept-offer")

  const acceptOffer = useCallback(
    async (offerId: bigint) => {
      const marketplace = config[MARKETPLACE_CHAIN_ID]?.contracts.marketplace

      const receipt = await writeContractAsync({
        address: marketplace!,
        abi: ABIOffersLogic,
        functionName: "acceptOffer",
        args: [offerId],
        chainId: MARKETPLACE_CHAIN_ID,
        loading: "Accepting offer...",
        success: "Offer accepted successfully!",
        error: "Failed to accept offer",
      })

      return receipt
    },
    [writeContractAsync],
  )

  return {
    acceptOffer,
    isPending,
  }
}
